import types from '../mutation-types';
import DashboardHomeAPI from '../../api/dashboardHome';

export const state = {
  data: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getHomeStats(_state) {
    return _state.data;
  },
  getMyStats(_state) {
    return _state.data.my_stats || {};
  },
  getCompanyStats(_state) {
    return _state.data.company_stats || {};
  },
  getLeaderboard(_state) {
    return _state.data.leaderboard || {};
  },
  getPipelines(_state) {
    return _state.data.pipelines || [];
  },
  getAlerts(_state) {
    return _state.data.alerts || [];
  },
  getMyStalledDeals(_state) {
    return _state.data.my_stalled_deals || [];
  },
  getMyTasks(_state) {
    return _state.data.my_tasks || [];
  },
  getMyMeetings(_state) {
    return _state.data.my_meetings || [];
  },
};

export const actions = {
  fetchHomeStats: async function fetchHomeStats({ commit }) {
    commit(types.SET_DASHBOARD_HOME_UI_FLAG, { isFetching: true });
    try {
      const response = await DashboardHomeAPI.getHomeStats();
      commit(types.SET_DASHBOARD_HOME_STATS, response.data);
    } catch {
      // falha pontual do fetch: a tela mantem o ultimo snapshot
    } finally {
      commit(types.SET_DASHBOARD_HOME_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_DASHBOARD_HOME_STATS](_state, data) {
    _state.data = data;
  },
  [types.SET_DASHBOARD_HOME_UI_FLAG](_state, flag) {
    _state.uiFlags = { ..._state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
